import UtensilsIcon from "./utensils-icon";

const Logo = () => {
  return (
    <h1 className="font-bold text-2xl md:text-4xl font-inter flex">
      <span>
        <UtensilsIcon color="#FFBB44" />
      </span>
      &nbsp;hungray
    </h1>
  );
};

export default Logo;
